const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#000000] border-t border-[#2F2F2F] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_find-your-agent/artifacts/m94nk0ss_NYAXO.png" 
              alt="NYAXO Logo" 
              className="h-16 mb-6"
            />
            <div className="space-y-4">
              <p className="text-white text-lg font-bold leading-relaxed">
                Engineering the Future of Intelligence
              </p>
              
              {/* Strong Points */}
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-1.5 h-1.5 bg-[#00E600] rounded-full mt-2"></div>
                  <p className="text-[#B3B3B3] text-sm leading-relaxed">
                    <span className="text-white font-semibold">We interrogate AI</span> — Testing systems others assume are ready
                  </p>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-1.5 h-1.5 bg-[#00E600] rounded-full mt-2"></div>
                  <p className="text-[#B3B3B3] text-sm leading-relaxed">
                    <span className="text-white font-semibold">We stress-test at scale</span> — Billion-dollar models, mission-critical infrastructure
                  </p>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-1.5 h-1.5 bg-[#00E600] rounded-full mt-2"></div>
                  <p className="text-[#B3B3B3] text-sm leading-relaxed">
                    <span className="text-white font-semibold">We engineer dominance</span> — Systems that don't just work, they transform industries
                  </p>
                </div>
              </div>
              
              <p className="text-[#00E600] text-sm font-semibold uppercase tracking-wide pt-2">
                Singapore • Global AI Innovation Hub
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4 uppercase tracking-wide">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/#services" className="text-[#B3B3B3] hover:text-[#00E600] transition-colors text-sm">Services</a></li>
              <li><a href="/live-demos" className="text-[#B3B3B3] hover:text-[#00E600] transition-colors text-sm">Live Demos</a></li>
              <li><a href="/NYAXO_Brochure.pdf" download className="text-[#B3B3B3] hover:text-[#00E600] transition-colors text-sm flex items-center">
                Download Brochure
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </a></li>
              <li><a href="/#contact" className="text-[#B3B3B3] hover:text-[#00E600] transition-colors text-sm">Contact Us</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4 uppercase tracking-wide">Contact</h3>
            <ul className="space-y-2">
              <li className="text-[#B3B3B3] text-sm">Nyaxo Pte. Ltd.</li>
              <li className="text-[#B3B3B3] text-sm">Singapore</li>
              <li className="mt-3"><a href="mailto:contact@nyaxo.net" className="text-[#00E600] hover:text-[#36E0A8] transition-colors text-sm">contact@nyaxo.net</a></li>
              <li className="text-[#B3B3B3] text-xs mt-4 pt-2 border-t border-[#2F2F2F]">
                <p className="font-semibold text-[#00E600] mb-1">Global Support:</p>
                APAC • Middle East • Europe
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2F2F2F] pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-[#B3B3B3] text-sm mb-4 md:mb-0 text-center md:text-left">
            <p>© {currentYear} Nyaxo Technologies Inc., Singapore</p>
            <p className="mt-1">All rights reserved.</p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="text-[#B3B3B3] hover:text-[#00E600] transition-colors text-sm">Privacy Policy</a>
            <a href="#" className="text-[#B3B3B3] hover:text-[#00E600] transition-colors text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;